import {AuthState} from '@/stores/AuthStore/AuthStore.types';

import {injected} from 'brandi';

import {HttpError, ProjectUserAuthState, ProjectUserAuthStatus} from '@specials/project-user';

import {ProjectUserInfoData, ProjectUserLoginData} from '@/services/ProjectAuthApi/types';
import {Store} from '@/stores/Store';

export class AuthStore extends Store<AuthState> {
  constructor() {
    super({status: ProjectUserAuthStatus.Loading, error: undefined});
  }

  public isLoggedIn = (): boolean => {
    return this.getState().status === ProjectUserAuthStatus.LoggedIn;
  };

  public isError = (): boolean => {
    return this.getState().status === ProjectUserAuthStatus.Error;
  };

  public isLoading = (): boolean => {
    return this.getState().status === ProjectUserAuthStatus.Loading;
  };

  public isGuest = (): boolean => {
    return this.getState().status === ProjectUserAuthStatus.Guest;
  };

  public setAuthStateGuest = (): void => {
    this.setState({
      status: ProjectUserAuthStatus.Guest,
      error: undefined,
    });
  };

  public setAuthStateLoading = (): void => {
    this.setState({
      status: ProjectUserAuthStatus.Loading,
      error: undefined,
    });
  };

  public setAuthState(projectUserAuthState: ProjectUserAuthState<ProjectUserInfoData, ProjectUserLoginData>): void {
    this.setState(this.mapProjectUserStateToAuthState(projectUserAuthState));
  }

  public getErrorData = (): HttpError => {
    if (!this.isError()) {
      throw new Error('Нет доступа к данным об ошибке');
    }
    const state = this.getState();

    return state.error as HttpError;
  };

  private mapProjectUserStateToAuthState = ({
    status,
    error,
  }: ProjectUserAuthState<ProjectUserInfoData, ProjectUserLoginData>): AuthState => {
    return {
      status,
      error,
    } as AuthState;
  };
}

injected(AuthStore);
